export function isIOS(platform: string, maxTouchPoints: number = 0) {
  if (/iPad|iPhone|iPod/.test(platform)) {
    return true
  } else {
    return maxTouchPoints > 2 && /MacIntel/.test(platform)
  }
}
export function isMobile(platform: string, maxTouchPoints: number = 0) {
  return /Android/i.test(platform) || isIOS(platform, maxTouchPoints)
}
